// @flow
import React from 'react'
import styled from 'styled-components'
import * as cf from 'cf'
import algoliasearch from 'algoliasearch'
import algoliasearchHelper from 'algoliasearch-helper'
import initStory from '../initialStory'

import alertStore from 'stores/alert'
const contentful = require('contentful')

type State = {
  locale: string,
  entry: string
}

async function fetchEntryFromAlgolia (entryId:string) {
  var client = algoliasearch('0BYMLMXGLI', '7058207f486c5d9c0a0e2d31fd10e7e5')
  var helper = algoliasearchHelper(client, 'magazine', {
    hitsPerPage: 1,
    attributesToHighlight: [],
    disjunctiveFacets: ['objectID']
  })
  helper.addDisjunctiveFacetRefinement('objectID', entryId)
  const hit = await helper.searchOnce().then(result => result.content.hits[0])

  if(hit) return hit.story
  else {
    var helper = algoliasearchHelper(client, 'pages', {
      hitsPerPage: 1,
      attributesToHighlight: [],
      disjunctiveFactes: ['objectID']
    })
    helper.addDisjunctiveFacetRefinement('objectID', entryId)
    const hit = await helper.searchOnce().then(result => result.content.hits[0])

    if(hit) return hit.story
    else {
      throw new Error('not objectID found ind indexes "pages" or "magazine"')
    }
  }

}

const client = contentful.createClient({
  space: 'qrma0jgw0rvs',
  accessToken: 'ca9b4e7de5544c9eaefcf53422ce8d8c570b3aea8529a10b64c0ebbd4ef92e56'
})

export default class CloneStory extends React.Component<{}, State> {

    state = {
        locale: '',
        entry: ''
    }

    handleLocaleChange = (locale:*) => this.setState({locale})

    handleButtonClick = async () => {
      if(!this.state.entry) return
      let result:any = null
      let error:any = null

      try {
        const entry = await client.getEntry(this.state.entry)
        result = entry.fields.story
      }
      catch(e){ error = e }

      if(!result){
        try {
          result = await fetchEntryFromAlgolia(this.state.entry)
          console.log(result)
          if(!result) throw new Error('keine story feld gefunden')
        }
        catch(e){
          alertStore.set({
            title: `Fehler (${this.state.entry})`,
            body: `[${error.toString()}] [${e.toString()}]`
          })
        }
      }

      if(result){
        alertStore.set({
          title: `Klonen (${this.state.entry})`,
          body: `Du bist kurz davor eine andere Story zu klonen.
          Damit werden alle Inhalte in diesem Feld überschrieben. Aller Komponenten
          werden restlos überschrieben. Bitte nur ausführen, wenn du weißt was du tust ;)`,
          onOk: () => cf.update(result)
        })
      }
    }

    render(){
        return (
            <Wrapper>
                <input placeholder='EntryID' value={this.state.entry} onChange={e => this.setState({entry: e.target.value})} />
                <Button className="Button" onClick={this.handleButtonClick}>Copy</Button>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
    display: flex;
    > input { 
      flex: 2; 
      margin-right: 5px; 
      padding-left: 10px;
      height: 45px;
      font-size: 22px;
    }
    > .Button { flex: 1; }
`

const Button = styled.div`
    background: rgb(0, 150, 136);
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`



// WEBPACK FOOTER //
// ./src/config/CloneStory.js